import { useState, useEffect } from 'react'

// Shows which network path served the dashboard, detected from response headers:
//   Tailscale  → Caddy stamps `X-Via-Tailscale` (fast, bypasses the Cloudflare tunnel)
//   Cloudflare → the public tunnel stamps `cf-ray`
//   Direct     → neither (plain LAN access)
const PATHS = {
  tailscale:  { icon: 'lock',  color: '#b0ceae',               label: 'Tailscale' },
  cloudflare: { icon: 'cloud', color: '#f6821f',               label: 'Cloudflare' },
  direct:     { icon: 'lan',   color: 'rgba(195,200,191,0.6)', label: 'Direkt' },
}

export default function ConnectionBadge() {
  const [path, setPath] = useState(null)

  useEffect(() => {
    fetch('/healthz', { cache: 'no-store' })
      .then(r => r.headers.get('cf-ray') ? 'cloudflare'
        : r.headers.get('x-via-tailscale') ? 'tailscale'
        : 'direct')
      .then(setPath)
      .catch(() => {})
  }, [])

  if (!path) return null
  const p = PATHS[path]
  return (
    <div
      title={`Verbindung: ${p.label}`}
      className="flex items-center gap-1.5 px-2 py-1 rounded-full"
      style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)' }}
    >
      <span className="material-symbols-outlined" style={{ fontSize: '0.85rem', color: p.color }}>{p.icon}</span>
      <span className="font-label text-[10px] hidden sm:block" style={{ color: p.color, letterSpacing: '0.04em' }}>{p.label}</span>
    </div>
  )
}
